import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { usePrefs, useLabels } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import { trackEvent } from 'ddc-track-event';
import { getVehicleObj } from '../../../utilities/vehicleTracking';
import { setModalSettings } from '../../../features/modalSettings';
import './VideoLinkButton.scss';

const VideoLinkButton = ({
	widgetName,
	windowId,
	uuid,
	videos,
	title,
	link,
	phone
}) => {
	const dispatch = useDispatch();
	const labels = useLabels();
	const { openVideoModalLabel } = usePrefs();

	return (
		<div className="video-link-wrapper">
			<button
				type="button"
				className={setClassNames([
					'video-link-button',
					'px-3',
					'py-3',
					'mr-3',
					'ml-3',
					'mb-3',
					'border-radius-sm'
				])}
				onClick={() => {
					trackEvent(widgetName, windowId, {
						element: 'Video button',
						result: 'Video modal displayed',
						vehicle: getVehicleObj(uuid)
					});

					dispatch(
						setModalSettings({
							isModalOpen: true,
							videos,
							uuid,
							title: title?.[0],
							link,
							phone
						})
					);
				}}
			>
				<i className="ddc-icon ddc-icon-play3 mr-3 video-link-button-text" />
				<span className="text-link text-link-muted ddc-font-size-xsmall font-weight-bold video-link-button-text">
					{labels.get(openVideoModalLabel)}
				</span>
			</button>
		</div>
	);
};

VideoLinkButton.propTypes = {
	widgetName: PropTypes.string.isRequired,
	windowId: PropTypes.string.isRequired,
	uuid: PropTypes.string.isRequired,
	videos: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			uri: PropTypes.string,
			title: PropTypes.string,
			provider: PropTypes.string
		})
	).isRequired,
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string)
	]).isRequired,
	link: PropTypes.string.isRequired,
	phone: PropTypes.string
};

VideoLinkButton.defaultProps = {
	phone: ''
};

export default VideoLinkButton;
